import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import TicketAttributeValue from 'models/ticket-attribute-value/ticket-attribute-value.model';
import ExternalFeature from 'models/external-feature/external-feature.model';

@Component({
  selector: 'app-fill-ticket-attribute',
  templateUrl: './fill-ticket-attribute.component.html',
  styleUrls: ['./fill-ticket-attribute.component.scss'],
})
export class FillTicketAttributeComponent implements OnInit {
  @Input() ticketAttribute: TicketAttribute = new TicketAttribute();
  @Input() filledSubject: Subject<TicketAttributeValue>;
  @Input() attributes: ExternalFeature;
  multiValue = [];

  ngOnInit() {
    if (this.ticketAttribute.auto) {
      if (this.attributes && this.attributes.other) {
        const key = this.ticketAttribute.ticketAttributeExtensions.find((ext) => ext.externalLayer.url === this.attributes.externalLayer.url) || { argisAttributeName: '' };
        this.fill(this.attributes.other[key.argisAttributeName]);
      } else {
        this.fill('');
      }
    }
  }

  isSelected(value) {
    return this.multiValue.includes(value);
  }

  fillDate(value) {
    this.multiValue = [value.valueOf().toString()];
  }

  fill(value: string) {
    this.filledSubject.next(new TicketAttributeValue({
      ticketAttribute: this.ticketAttribute,
      value: [value],
    }));
  }

  fillMulti(value: string) {
    if (this.multiValue.includes(value)) {
      this.multiValue.splice(this.multiValue.indexOf(value), 1);
    } else {
      this.multiValue.push(value);
    }
  }

  next() {
    this.filledSubject.next(new TicketAttributeValue({
      ticketAttribute: this.ticketAttribute,
      value: this.multiValue,
    }));
  }
}
